import { render } from "./ParticipantTicketAndQR.vue?vue&type=template&id=1c8949f2&scoped=true&ts=true"
import script from "./ParticipantTicketAndQR.vue?vue&type=script&lang=ts"
export * from "./ParticipantTicketAndQR.vue?vue&type=script&lang=ts"

import "./ParticipantTicketAndQR.vue?vue&type=style&index=0&id=1c8949f2&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8949f2"]])

export default __exports__